module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/Dec18_Broadway_Kathy_CR-7b6b9bf6e94231f0d844eaf54cd4d863.jpg";